export const signInData = {
  emailusername: "",
  password: "",
};

export const signUpData = {
  email: "",
  userName: "",
  fullName: "",
  password: "",
  gender: "",
  confirmPassword: "",
};

export const forgotPasswordData = {
  email: "",
  confirmEmail: "",
};

export const resetPasswordData = {
  password: "",
  confirmPassword: "",
};

export const genderOptions = ["male", "female", "other"];
